import {
  CREDIT_LIMIT_DANGER_THRESHOLD,
  CREDIT_LIMIT_WARNING_THRESHOLD,
} from '@/constants/billing';

export type CreditLimitStatusType = 'warning' | 'danger' | null;

export function computeCreditLimitStatus(
  creditsUsed: number | null | undefined,
  creditLimit: number | null | undefined,
): CreditLimitStatusType {
  if (!creditLimit || creditsUsed == null) return null;
  const ratio = creditsUsed / creditLimit;
  if (ratio >= CREDIT_LIMIT_DANGER_THRESHOLD) return 'danger';
  if (ratio >= CREDIT_LIMIT_WARNING_THRESHOLD) return 'warning';
  return null;
}
